export default "__VITE_ASSET__B3CZ3lNe__"